import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  container: {
    marginTop: 20,
  },
}));
